var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolyU(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 253 256",
    style: {
      enableBackground: "new 0 0 253 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8F1329;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.7,81.4c9.7-2.1,19.9-1.2,29.1,2.6l52.3-52.3c7.3-7.3,19.4-7,26.6,0.3c7.3,7.3,7.3,19.4,0,26.7l-13.4,13.4 L106.2,52l-16,16l56.4,56.4l15.9-16l-20.1-20.1L155.8,75l0.1-0.1c16.2-16.2,16.2-42.5,0-58.8c-16.2-16.2-42.6-16.3-58.8-0.1 C97.1,16.1,31.6,81.5,31.7,81.4 M175,35.3c2.1,9.7,1.2,19.9-2.6,29.1l52.3,52.3c7.3,7.3,7,19.4-0.2,26.6c-7.3,7.3-19.5,7.3-26.7,0 l-13.4-13.4l20.1-20.1l-15.9-16l-56.4,56.4l16,15.9l20.1-20.1l13.3,13.3l0.1,0.1c16.2,16.2,42.5,16.2,58.8,0 c16.2-16.2,16.3-42.6,0.1-58.8C240.4,100.6,175,35.2,175,35.3 M221.3,178.5c-9.7,2.1-19.9,1.2-29.1-2.6l-52.3,52.3 c-7.3,7.3-19.4,7-26.6-0.3c-7.3-7.3-7.3-19.4,0-26.7l13.4-13.4l20.1,20.1l16-15.9l-56.4-56.4l-15.9,15.9l20.1,20.1l-13.3,13.3 l-0.1,0.1c-16.2,16.2-16.2,42.5,0,58.8s42.6,16.3,58.8,0.1C155.9,243.9,221.3,178.4,221.3,178.5 M78,224.7 c-2.1-9.7-1.2-19.8,2.6-29.1l-52.3-52.3c-7.3-7.3-7-19.3,0.3-26.6c7.3-7.3,19.4-7.3,26.7,0L68.7,130l-20.1,20.1l16,16l56.4-56.4 l-15.9-16l-20.1,20.1l-13.3-13.3l-0.1-0.1c-16.2-16.2-42.5-16.2-58.8,0s-16.3,42.6-0.1,58.8C12.6,159.3,78,224.8,78,224.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolyU);
export default __webpack_public_path__ + "static/media/PolyU.4ee384e273c3a99909cadcd8ed464628.svg";
export { ForwardRef as ReactComponent };